import {WsService} from "../sys/ws.service";
import {Injectable} from "@angular/core";
import {AfsForm} from "../model/afsForm";
import {QueryStringBuilderService} from "./query-string-builder.service";
import {SettingsService} from "../sys/settings.service";
import {Bucket} from "../model/bucket";
import {TablePositionStatus} from "../model/tablePositionStatus";
import {StaticsService} from "../sys/statics.service";

declare var $: any;

@Injectable()
export class ApplicationService {
    private afsForm: AfsForm;
    private csvForm: AfsForm;

    private tablePositionStatus = new TablePositionStatus();

    constructor(protected wsService: WsService,
                protected settingsService: SettingsService,
                protected staticsService: StaticsService,
                protected queryStringBuilderService: QueryStringBuilderService) {

        this.resetTablePositionStatus();
    }

    public getCsvForm(): AfsForm {
        return this.csvForm;
    }

    public getAfsForm(): AfsForm {
        return this.afsForm;
    }

    public setAfsForm(afsForm: AfsForm) {
        this.afsForm = afsForm;
    }

    public getTablePositionStatus() : TablePositionStatus {
        return this.tablePositionStatus;
    }

    public setTablePositionStatus(tablePositionStatus: TablePositionStatus){
        this.tablePositionStatus = tablePositionStatus;
    }

    public resetTablePositionStatus() {
        this.tablePositionStatus.paginatorPos= "0";
        this.tablePositionStatus.isPaginatorEvent = false;
        this.tablePositionStatus.sortField = this.staticsService.getSortColumn().PLANNAME;
        this.tablePositionStatus.sortDirection = this.staticsService.getDirection().DIRECTION_ASC;
    }

    public retrieveCsv(): Promise<any> {


        return new Promise(resolve => {
            // this is needed for non-search calls- not sure I this but every other event reqiures back to 0
            this.getTablePositionStatus().isPaginatorEvent = true;

            let params: Map<string, string> = this.setupParams();

            this.wsService.executeWS("/csv", params).subscribe((data: any) => {
                this.csvForm = data;
                resolve(null);
            });
        });
    };

    private setupParams():Map<string,string> {
        const queryStr = this.queryStringBuilderService.getQueryString();
        let params :Map<string,string> = new Map();
        if (queryStr.length == 0) {
            params.set('size', "0");
            params.set('q', "(*:*)");
        }
        else {
            params.set('size', this.settingsService.getRecordsMax());
            if (this.getTablePositionStatus().isPaginatorEvent) {
                params.set('start', this.getTablePositionStatus().paginatorPos);
                this.getTablePositionStatus().isPaginatorEvent = false;
            }
            else {
                this.getTablePositionStatus().paginatorPos = "0";
            }

            params.set('sort', this.getTablePositionStatus().sortField + " " + this.getTablePositionStatus().sortDirection);
            params = params.set('q', queryStr);
        }
        return params;
    }

    public search(): Promise<any> {

        return new Promise(resolve => {
            let params :Map<string,string> = this.setupParams();
            params = this.addFacetParams(params);
            this.wsService.executeWS("", params).subscribe((data: any) => {
                this.afsForm = data;
                resolve(null);
            });
        });
    };

    public isDCGRowExisting() : boolean {
        var exists = false;

        if (this.getAfsForm().hits != undefined) {
            for (var hit of this.getAfsForm().hits.hit) {
                if (hit.fields.dcgind === "1") {
                    exists = true;
                }
            }
        }
        return exists;
    }
    
    // This is needed to tell the server we need these facets returned for every call
    private addFacetParams(params: Map<string,string>): Map<string,string> {
        params.set('facet.planyear', "%7Bsize:30%7D&facet.plancode=%7Bsize:100%7D");
        params.set('facet.plancode', "%7Bsize:100%7D");
        params.set('facet.assetseoy', "%7Bbuckets:[%22%7B,100000]%22,%22[100001,500000]%22,%22[500001,1000000]%22,%22[1000001,10000000]%22,%22[10000001,%7D%22]%7D");
        params.set('facet.plantype', "%7Bsize:20%7D");
        params.set('facet.businesscodecat', "%7Bsize:30%7D");
        params.set('facet.businesscode', "%7Bsize:30%7D");
        params.set('facet.state', "%7Bsize:100%7D");
        params.set('facet.countrycode', "%7Bbuckets:%5B%22CA%22,%22GB%22,%22BM%22,%22KY%22%5D%7D");
        params.set('facet.formyear', "%7Bsize:30%7D");

        return params;
    }

    public getFacetBucketsByType(type: string): Bucket[] {
        let buckets: Bucket[] = new Array();

        return buckets;

    }
}
